module.exports = __webpack_public_path__ + "static/media/25_plantilla_combo_rectangular_marco_comida_69.e1654d73.png";